/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Workflow_Step4title1Inputs */

const zh_landing_workflow_step4title1 = /** @type {(inputs: Landing_Workflow_Step4title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让 AI 反馈真正帮到学生`)
};

const en_landing_workflow_step4title1 = /** @type {(inputs: Landing_Workflow_Step4title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use AI feedback that actually helps`)
};

const es_landing_workflow_step4title1 = /** @type {(inputs: Landing_Workflow_Step4title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa feedback con IA que realmente ayuda`)
};

/**
* | output |
* | --- |
* | "Use AI feedback that actually helps" |
*
* @param {Landing_Workflow_Step4title1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_workflow_step4title1 = /** @type {((inputs?: Landing_Workflow_Step4title1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Workflow_Step4title1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_workflow_step4title1(inputs)
	if (locale === "en") return en_landing_workflow_step4title1(inputs)
	return es_landing_workflow_step4title1(inputs)
});
export { landing_workflow_step4title1 as "landing_workflow_step4Title" }